import DataTable, { defaultThemes } from 'react-data-table-component';
import { IEcd } from '../../interfaces/IRelatorio';

function EcdTabela({ colunas, itens, acaoTocarLinha }: { colunas: any, itens: IEcd[], acaoTocarLinha?: (ecd: IEcd) => void }) {
    const customStyles = {
        headCells: {
            style: {
                color: '#5E6397',
                fontFamily: 'Assistant',
                fontSize: '18px',
                paddingTop: '15px',
                paddingBottom: '15px',
                ':last-child': {
                    maxWidth: '1rem',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default
                },
                ':nth-child(2n), :nth-child(3n)': {
                    maxWidth: '11rem'
                },
                ':nth-child(4n)': {
                    maxWidth: '13rem'
                },
                ':first-child': {
                    maxWidth: '60rem',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default
                },
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default
            },
        },
        cells: {
            style: {
                color: '#A3A3A3',
                fontFamily: 'Merriweather Sans',
                fontSize: '16px',
                paddingTop: '15px',
                paddingBottom: '15px',
                cursor: 'pointer',
                ':last-child': {
                    maxWidth: '1rem',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
                ':nth-child(2n), :nth-child(3n)': {
                    maxWidth: '11rem'
                },
                ':nth-child(4n)': {
                    maxWidth: '13rem'
                },
                ':first-child': {
                    maxWidth: '60rem',
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default,
                    color: '#525252',
                },
                borderBottomStyle: 'solid',
                borderBottomWidth: '1px',
                borderBottomColor: defaultThemes.default.divider.default,
            },
        }
    };

    return <>
        {
            itens.length > 0 ? 
                // <div style={{ width: '950px' }}>
                    <DataTable columns={colunas} data={itens} customStyles={customStyles} dense onRowClicked={acaoTocarLinha} />
                // </div>
            : <h2 className="mt-5">Não existem ECDs para serem exibidos</h2>
        }
    </>
}


export default EcdTabela;